/**
 * Extracts the trailing id from a housing uri.
 *
 * @returns number | undefined
 */
export default function (): number | undefined {
  const route = useRoute();
  const slugs = route.params.slug;
  const housingUri = Array.isArray(slugs) ? slugs[slugs.length - 1] : slugs;

  const match = housingUri ? housingUri.match(/(\d+)$/) : undefined;
  return match ? parseInt(match[0]) : undefined;
}
